import parse from 'html-react-parser';
import * as React from 'react';

import { CLIP_SOURCE_TYPE, clipSource } from '../../libs/speech/clipSource';
import { useReadAloud } from '../readAloud/readAloudContext';
import { ReadAloudSection } from '../readAloud/readAloudSection';

const PlayTitleCard = ({ data, handleContinueClick, isLastQuestion, previewMode }) => {
  const { readAloudEnabled, } = useReadAloud();
  const buttonText = isLastQuestion ? 'Next' : 'Continue';
  const disabled = previewMode && isLastQuestion;
  const disabledClass = disabled ? 'disabled' : '';
  return(
    <div className="landing-page-html">
      {readAloudEnabled ? <ReadAloudSection html={data.content} label="Read this page aloud" source={clipSource(CLIP_SOURCE_TYPE.TITLE_CARD, data.uid)} /> : <div>{parse(data.content)}</div>}
      <button className={`quill-button focus-on-light large green contained ${disabledClass}`} disabled={disabled} onClick={handleContinueClick} type="button">
        {buttonText}
      </button>
    </div>
  );
}

export { PlayTitleCard };

